module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-gray page-flex"
  }, [_c('appStatus', {
    attrs: {
      "statusHeight": _vm.statusHeight
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-input-title",
    style: ({
      top: _vm.statusHeight + 'rem'
    })
  }, [_c('div', {
    staticClass: "alifont icon-back left-icon click",
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pageInfo.shopName),
      expression: "pageInfo.shopName"
    }],
    staticClass: "center-input fs-28",
    attrs: {
      "type": "search",
      "placeholder": "搜索柜子"
    },
    domProps: {
      "value": (_vm.pageInfo.shopName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        return _vm.handleQuery.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pageInfo, "shopName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right fs-28 color-333 click",
    on: {
      "click": _vm.handleQuery
    }
  }, [_vm._v("\n            搜索\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex1 posi-rel pb-250"
  }, [_c('scroller', {
    ref: "scroller",
    attrs: {
      "on-refresh": _vm.loadNewData,
      "on-infinite": _vm.loadMore
    }
  }, _vm._l((_vm.data), function(item, $index) {
    return _c('div', {
      key: $index,
      staticClass: "cabin click",
      on: {
        "click": function($event) {
          _vm.getScrollerPosition();
          _vm.$router.push({
            name: 'equipmentHome',
            query: {
              shopId: item.shopId
            }
          })
        }
      }
    }, [_c('div', {
      staticClass: "fs-36 color-333 flex-center pd-250 bd-bot"
    }, [(item.shopType == '1') ? _c('div', {
      staticClass: "supply-label"
    }, [_vm._v(_vm._s(_vm.equipment_type[item.equipmentType]))]) : _vm._e(), _vm._v(" "), (item.shopType == '2') ? _c('div', {
      staticClass: "supply-label"
    }, [_vm._v(_vm._s(_vm.equipment_type['huodong']))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(item.shopName))])]), _vm._v(" "), _c('div', {
      staticClass: "fs-30 color-999 address"
    }, [_vm._v(_vm._s(item.address))])])
  }), 0)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17c0017c","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/equipment/equipmentList.vue
// module id = L33u
// module chunks = 51